import axios from 'axios';
import { BACKEND_URL } from './config';
import { attachAuthRefreshInterceptor } from './authRefreshInterceptor';
import { attachUiLanguageHeader } from './uiLanguageHeader';

// Helper to get cookie value by name
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Create axios instance with base URL from runtime config or environment variable
const axiosInstance = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Required for CSRF cookies
});

// Add request interceptor to include CSRF token
// SECURITY: Auth token is sent via httpOnly cookie (withCredentials: true)
axiosInstance.interceptors.request.use(
  (config) => {
    // Add CSRF token for state-changing requests
    const method = config.method?.toUpperCase();
    if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
      const csrfToken = getCookie('csrf_token');
      if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 401 token refresh — shared with AuthContext's instance via
// authRefreshInterceptor.js (axios interceptors don't inherit across
// axios.create() instances, so this needs its own attachment; the two share
// the same isRefreshing/failedQueue state so they can't race each other).
attachAuthRefreshInterceptor(axiosInstance);
attachUiLanguageHeader(axiosInstance);

export default axiosInstance;
